import { PropsWithChildren } from "react";
import Spinner from "../spinner";

const IconButton = ({
  className = "",
  activeClass = "dr-border-darwin-touch-neutral-100 dr-bg-darwin-touch-neutral-50 hover:dr-bg-darwin-touch-neutral-100 focus:dr-bg-darwin-touch-neutral-50",
  disabledClass = "",
  children,
  icon = <></>,
  loading,
  disabled = false,
  ...others
}: PropsWithChildren<
  {
    activeClass?: string;
    disabledClass?: string;
    loading?: boolean;
    icon: React.ReactNode;
    className?: string;
  } & React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >
>) => {
  return (
    <button
      disabled={disabled}
      className={`dr-rounded-4 dr-h-full dr-border-1 dr-border-solid dr-flex dr-justify-center dr-items-center dr-space-x-8 ${className} ${
        disabled ? disabledClass : activeClass
      }`}
      {...others}
    >
      {loading ? <Spinner className="dr-h-24 dr-w-24 dr-max-w-24" /> : icon}
      {children}
    </button>
  );
};

export default IconButton;
